import React, { useState } from 'react';
import { Button as ANTButton, Form, notification, Switch } from 'antd';
import { Button } from '../../../components/Atom/Button';
import Input from 'components/Atom/Input';
import { PageHeader } from '../../../components/Atom/PageHeader';
import Select from 'components/Atom/Select';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import http from '../../../utils/http';
import { setStore } from 'app/features/userSlice';
export const EditSubscription = () => {
  const location = useLocation();
  const isEdit = location?.state?.isEdit;
  const subscription = location?.state?.subscription;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const store = useSelector((state) => state?.company?.store);
  const userStores = useSelector((state) => state?.company?.userStores);

  const onSubmit = async (values) => {
    if (userStores?.length > 1 && !store?.isSelected) {
      notification.error({ message: 'Select store from the drop-down menu above', placement: 'bottomRight' });
      return;
    }
    setLoading(true);
    try {
      const { allow_past_due_cancel, allow_past_due_pause, allow_past_due_skip, send_payment_link_on_inactive, allowed_retries, invoice_action, subscription_action } = values;
      const payload = {
        subscription: {
          allow_past_due_cancel,
          allow_past_due_pause,
          allow_past_due_skip,
          send_payment_link_on_inactive,
          allowed_retries,
          invoice_action: invoice_action?.value,
          subscription_action: subscription_action?.value,
        },
      };

      const res = await http.put(`/stores/${store?._id}`, payload);
      if (res?.data?.success) {
        notification.success({ message: 'Data Edit Successfully', placement: 'bottomRight' });
        dispatch(setStore({ ...res?.data?.data, isSelected: true }));
        navigate(`/setting/subscriptionDetails`);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
      notification.error({ message: err?.response?.data?.message || 'Data not update', placement: 'bottomRight' });
    }
  };
  const invoiceActionOptions = [
    {
      label: 'Open',
      value: 'open',
    },
    {
      label: 'Draft',
      value: 'draft',
    },
    {
      label: 'Paid',
      value: 'paid',
    },
  ];
  const subscriptionActionOptions = [
    {
      label: 'Paid',
      value: 'paid',
    },
    {
      label: 'Inactive',
      value: 'inactive',
    },
    {
      label: 'Paused',
      value: 'paused',
    },
    {
      label: 'Cancelled',
      value: 'cancelled',
    },
  ];
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Subscription Details',
        href: '/setting/subscriptionDetails',
      },
      {
        name: `${isEdit ? 'Update' : 'Add'}`,
      },
    ],
  };
  const initialValues = isEdit && {
    allow_past_due_cancel: subscription?.allow_past_due_cancel,
    allow_past_due_pause: subscription?.allow_past_due_pause,
    allow_past_due_skip: subscription?.allow_past_due_skip,
    send_payment_link_on_inactive: subscription?.send_payment_link_on_inactive,
    allowed_retries: subscription?.allowed_retries,
    invoice_action: subscription?.invoice_action,
    subscription_action: subscription?.subscription_action,
  };
  return (
    <>
      <div className='header-container p-4'>
        <div>
          <Breadcrumbs {...breadcrumbProps} />
        </div>
        <div className='headerPage mobileContainer'>
          <div>
            <PageHeader label={isEdit ? 'Update Subscription' : 'Add Subscription'} />
          </div>
        </div>
      </div>
      <Form layout='vertical' initialValues={initialValues} onFinish={onSubmit} method='post' className='input-form-wrapper'>
        <Form.Item
          name='allowed_retries'
          label='Allowed Retries  (Up to 6 allowed)'
          className='customInput mobileInputView steric-after'
          rules={[
            {
              required: true,
              message: 'Retry is required',
            },
          ]}>
          <Input type='number' placeholder='Enter Allowed Retries' name='allowed_retries' min={0} max={6} />
        </Form.Item>
        <Form.Item name='invoice_action' label='Invoice Action' className='customInput mobileInputView'>
          <Select defaultValue={'Select Invoice Action'} optionsValue={invoiceActionOptions} />
        </Form.Item>
        <Form.Item name='subscription_action' label='Subscription Action' className='customInput mobileInputView'>
          <Select defaultValue={'Select Subscription Action'} optionsValue={subscriptionActionOptions} />
        </Form.Item>
        <Form.Item name='allow_past_due_cancel' initialValue={false} label='Allow Past Due Cancel' valuePropName='checked' className='customInput mobileInputView'>
          <Switch defaultChecked />
        </Form.Item>
        <Form.Item name='allow_past_due_pause' initialValue={false} label='Allow Past Due Pause' valuePropName='checked' className='customInput mobileInputView'>
          <Switch defaultChecked />
        </Form.Item>
        <Form.Item name='allow_past_due_skip' initialValue={false} label='Allow Past Due Skip' valuePropName='checked' className='customInput mobileInputView'>
          <Switch defaultChecked />
        </Form.Item>
        <Form.Item name='send_payment_link_on_inactive' initialValue={false} label='Send Payment Link on Inactive' valuePropName='checked' className='customInput mobileInputView'>
          <Switch defaultChecked />
        </Form.Item>
        <div className='mb-[-20px] form_button update-button'>
          <Form.Item>
            <div className='flex ' style={{ justifyContent: 'right' }}>
              <ANTButton
                className='rounded-lg'
                block
                onClick={() => {
                  navigate(`/setting/subscriptionDetails`);
                }}>
                Cancel
              </ANTButton>
              <Button type='primary' block className='primaryBtn ml-4' htmlType='submit' loading={loading}>
                {isEdit ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};
